// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "(max-width: 1024px)";
var _3 = "screen and (max-width: 600px)";
var _4 = "selector-2yoqY";
var _5 = "header-3418J";
var _6 = "header__arrow-1EcBY";
var _7 = "description-3OBjU";
var _8 = "arrow-1Efj6";
export { _1 as "__esModule", _2 as "tablet", _3 as "mobile", _4 as "selector", _5 as "header", _6 as "header__arrow", _7 as "description", _8 as "arrow" }
export default { "__esModule": _1, "tablet": _2, "mobile": _3, "selector": _4, "header": _5, "header__arrow": _6, "description": _7, "arrow": _8 }
